<template>
	<div class="page-home">
		<section class="slider">
			<div class="overtext">
<!-- 				<div class="container">
					We make security ipsum
				</div> -->
			</div>
			<div id="carousel" class="carousel slide" data-ride="carousel" data-interval="6500" data-pause="false" data-keyboard="true">
				<div class="carousel-inner">
					<div class="carousel-item active">
						<img class="d-block w-100" src="@/assets/slide-2.jpg">
					</div>
					<div class="carousel-item">
						<img class="d-block w-100" src="@/assets/slide-3.jpg">
					</div>
					<div class="carousel-item">
						<img class="d-block w-100" src="@/assets/slide-4.jpg">
					</div>
				</div>
			</div>
		</section>
		<section class="container">
			<div class="row align-items-center">
				<div class="col-md-6 spaced-sm">
					<h2>Aedil</h2>
					<p class="lead pr-md-35">We focus on solving problems without adding unnecessary complexity for the user</p>
					<router-link to="/about">Learn More »</router-link>          
				</div>
				<div class="col-md-6">
					<img src="@/assets/about.jpg" alt="About us">
				</div>
			</div>
		</section>
<!-- 		<section class="whatwedo gray-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-7 text-center">
						<h2>What we do?</h2>
						<p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam, consequuntur eligendi a architecto est ab explicabo sequi voluptatem veritatis dolorum beatae inventore.</p>
					</div>
				</div>
			</div>
		</section> -->
		<section class="cta">
			<div class="container">
				<div class="col-md-6">
<!-- 					<h2>Lorem ipsum dolor sit amet</h2>
					<p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam, consequuntur eligendi a architecto est sed ab explicabo sequi.</p> -->
					<router-link to="/contact" class="btn btn-primary btn-main">Get in touch</router-link>
				</div>
			</div>
		</section>
	</div>	
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import $ from 'jquery';

import $ from 'jquery';
import 'bootstrap';

export default {
	name: 'Home',
	components: {

	},
	mounted() {
		$("#carousel").carousel();
	}
}
</script>
